import React, {useEffect, useState, useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal, Button, Spinner} from 'react-bootstrap'
import CreateScriptBody from './CreateScriptBody'
import CreatePrompts from './CreatePrompts'
import CreatePreview from './CreatePreview'
import {
  GETLANGUAGE,
  GETPRODUCTLIST,
  CREATESCRIPT,
  GETSCRIPTBYID,
  UPDATESCRIPT,
  GET_SCRIPT_DIALINNUMBERS,
  GET_CLIENT_ALLOWED_COMPONENTS,
} from '../../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import './multiselectOverride.css'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {alert} from '../../../../../utils/helper'
import DialInNumber from './DialInNumber'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'

const MySwal = withReactContent(Swal)
const modalsRoot = document.getElementById('root-modals') || document.body

const CreateScript = ({
  show,
  setShowModal,
  getScriptList,
  modalConfig,
  loadedData,
  setLoadedData,
  audio,
}: any) => {
  const [currentScreen, setCurrentScreen] = useState('createScript')
  const [languages, setLanguages] = useState<any>([])
  const [products, setProducts] = useState([])
  const [dialInNumbers, setDialInNumbers] = useState([])

  const networkOnly = 'network-only'
  const [isSolarProduct, setIsSolarPRoduct] = useState<any>(false)

  //to store data of languageIDs,products IDs so that we can compare and seperate added and delete Data for API
  const [dataFromGetscript, setDataFromGetScript] = useState<any>({
    exisitingLanguages: [],
    existingLanguagesMasterId: [],
    existingProducts: [],
    existingQuestions: [],
  })
  const [payload, setPayload] = useState({
    isActive: true,
    tpvType: 'IVR',
    languageIds: [],
    name: '',
    scriptDescription: '',
    timeConditionCheck: true,
    voice: 'Male',
    scriptQuestions: [],
    productIds: [],
    deleteProducts: [],
    deleteScriptLanguages: [],
    deleteScriptQuestions: [],
  })
  const [isplayingplayAll, setIsPlayingPlayAll] = useState(false)
  //to populate the language dropdown
  const [getLanguages] = useLazyQuery(GETLANGUAGE, {
    onCompleted: (data) => {
      setLanguages(
        data.getAllLanguages.map((language: any) => {
          return {label: language.languageName, value: language.id}
        })
      )
      if (modalConfig.mode === 'create') {
        setSelectedLanguage([
          {label: data.getAllLanguages[0].languageName, value: data.getAllLanguages[0].id},
        ])
        //to add setup for default value script question
        setPayload((prev: any) => {
          return {
            ...prev,
            scriptQuestions: [
              ...prev.scriptQuestions,
              {
                languageId: `${data.getAllLanguages[0].id}`,
                languageName: `${data.getAllLanguages[0].languageName}`,
                questions: [],
              },
            ],
            languageIds: [...prev.languageIds, data.getAllLanguages[0].id],
          }
        })
      }
    },
    onError: (err) => console.error('error', err),
    fetchPolicy: networkOnly,
  })

  const [getClientAllowedComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setIsSolarPRoduct(data?.getClientAllowedComponents.includes('solarProductSetup'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  useEffect(() => {
    getClientAllowedComponents()
  }, [])

  //to populate the product dropdown
  const [getProductList] = useLazyQuery(GETPRODUCTLIST, {
    variables: {
      productListFilterInput: {
        isActive: true,
        searchText: '',
      },
      withDual: false,
    },
    onCompleted: (data) => {
      setProducts(
        data.getProductListByTeamAdmin.products.map((product: any) => {
          return {
            label: product.productName,
            value: product.prodId,
            disabled: product.tpvScriptStatus === 'ASSIGNED',
          }
        })
      )
      modalConfig.mode === 'create' && setLoadedData(true)
    },
    onError: (err) => console.error('error', err),
    fetchPolicy: networkOnly,
  })

  const [createScript] = useMutation(CREATESCRIPT, {
    onCompleted: () => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Script created successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      getScriptList()
      handleModalClose()
    },
    onError: (err) => alert(err.message, 'error'),
  })

  const [updateScript] = useMutation(UPDATESCRIPT, {
    onCompleted: () => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Script updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      getScriptList()
      handleModalClose()
    },
    onError: (err) => alert(err.message, 'error'),
  })

  const [getscriptById] = useLazyQuery(GETSCRIPTBYID, {
    onCompleted: ({getScript}) => {
      setPayload((prev: any) => {
        return {
          ...prev,
          isActive: getScript.isActive,

          languageIds:
            modalConfig.mode === 'clone'
              ? getScript?.scriptLanguages.map((language: any) => language.language.id)
              : [],
          name: modalConfig.mode === 'clone' ? '' : getScript.name,
          scriptDescription: getScript.scriptDescription,
          timeConditionCheck: getScript.timeConditionCheck,
          voice: getScript.voice,
          tpvType: getScript.tpvType,
          scriptQuestions: getScript?.scriptLanguages?.map((language: any) => {
            return {
              languageId: language.language.id,
              questions: language.questions,
            }
          }),
        }
      })
      //set selected products for only edit mode not for clone
      modalConfig.mode === 'edit' &&
        setSelectedProducts(
          getScript.products.map(({product}: any) => {
            return {label: product.name, value: product.id}
          })
        )
      setSelectedLanguage(
        getScript.scriptLanguages.map(({language}: any) => {
          return {label: language.languageName, value: language.id}
        })
      )
      //set product and language data got from get script to check while deleting the Data includes this ID's so that we can add in update API call

      setDataFromGetScript((prevData: any) => {
        const tempQuestions: any = []
        getScript.scriptLanguages.forEach(({questions}: any) => [
          ...questions.map((question: any) => tempQuestions.push(question.id)),
        ])
        return {
          exisitingLanguages: getScript.scriptLanguages.map(({language}: any) => language.id),
          //set Existing products for only edit mode not for clone
          existingProducts:
            modalConfig.mode === 'edit'
              ? getScript.products.map(({product}: any) => product.id)
              : [],
          existingLanguagesMasterId: getScript.scriptLanguages.map(({id, language}: any) => {
            return {
              languageId: language.id,
              masterId: id,
            }
          }),
          existingQuestions: tempQuestions,
        }
      })
      setProducts((prevProducts: any) => {
        const apiProductIds = getScript.products.map(({product}: any) => product.id)
        return prevProducts.map((product: any) => {
          if (modalConfig.mode === 'edit' && apiProductIds.includes(product.value)) {
            return {
              ...product,
              disabled: false,
            }
          } else {
            return product
          }
        })
      })
    },
    onError: (err) => {
      MySwal.fire({
        icon: 'error',
        title: err.message,
      })
      handleModalClose()
    },
    fetchPolicy: networkOnly,
  })
  const [getDialInNumbersByType] = useLazyQuery(GET_SCRIPT_DIALINNUMBERS, {
    fetchPolicy: 'network-only',
    onCompleted: ({getScriptDialNumbers}) => {
      //setDialInNumbers(getScriptDialNumbers.dailInNumber)
      setDialInNumbers((prev: any) => {
        return {
          ...prev,
          dialInNumberIVR: getScriptDialNumbers.dailInNumber[0],
          dialInNumberLiveAgentEng: getScriptDialNumbers.englishDialInNumberLA,
          dialInNumberLiveAgentSpn: getScriptDialNumbers.spanishDialInNumberLA,
        }
      })
    },
  })

  useEffect(() => {
    if (currentScreen) {
      cancelAudio()
    }
  }, [currentScreen])
  //to cancel the audio playback
  const cancelAudio = () => {
    if (!audio?.paused) {
      audio?.pause()
      setSpeakingId('')
    }
    if (isplayingplayAll && !audioRef?.current?.paused) {
      audioRef?.current?.pause()
      setSpeakingId('')
    }
    isplayingplayAll && setIsPlayingPlayAll(false)
  }
  const handleModalClose = () => {
    setPayload({
      isActive: true,
      tpvType: 'IVR',
      languageIds: [],
      name: '',
      scriptDescription: '',
      timeConditionCheck: true,
      voice: 'Male',
      scriptQuestions: [],
      productIds: [],
      deleteProducts: [],
      deleteScriptLanguages: [],
      deleteScriptQuestions: [],
    })

    setDataFromGetScript({
      exisitingLanguages: [],
      existingProducts: [],
      existingQuestions: [],
    })

    if (Boolean(speakingId)) {
      cancelAudio()
    }

    setShowModal(false)
  }
  useEffect(() => {
    if (show) {
      setSelectedProducts([])
      setSelectedLanguage([])
      setCurrentScreen('createScript')
      ;(async () => {
        //we have to call edit script only after the getProductList call,so that we can enable the script assigned to this product so async is used

        await getLanguages()
        await getProductList()
        await getDialInNumbersByType({
          variables: {
            tpvType: 'BOTH',
          },
        })

        if (modalConfig.mode === 'create') {
        } else if (
          modalConfig.mode === 'edit' ||
          modalConfig.mode === 'clone' ||
          modalConfig.mode === 'preview'
        ) {
          await getscriptById({variables: {getScriptId: modalConfig.scriptId}})
          if (modalConfig.mode === 'preview') {
            setCurrentScreen('preview')
          }
          setLoadedData(true)
        }
      })()
    }
  }, [show])

  const [selectedLanguage, setSelectedLanguage] = useState<any>([])
  const [selectedProducts, setSelectedProducts] = useState([])

  const handleCreatePrompt = () => {
    setCurrentScreen('createPrompt')
  }
  //api payload helper
  const handleAPI = () => {
    let finalpayload = {
      ...payload,
      scriptQuestions: payload.scriptQuestions.map((language: any) => {
        let formattedQuestions = language.questions.map((question: any, index: any) => {
          //for edit mode we have to return the questions with question Id
          if (modalConfig.mode === 'edit') {
            //if question id is in exisiting language Id then return with question id
            if (dataFromGetscript.existingQuestions.includes(question.id)) {
              return {
                description: question.description.replaceAll('[', '{').replaceAll(']', '}'),
                position: index + 1,
                questionType: question.questionType,
                questionId: question.id,
                continueCall: question.continueCall,
                scriptType: question.scriptType,
              }
            } else {
              //if question id is in exisiting language Id then its added language so return without question id
              return {
                description: question.description.replaceAll('[', '{').replaceAll(']', '}'),
                position: index + 1,
                questionType: question.questionType,
                continueCall: question.continueCall,
                scriptType: question.scriptType,
              }
            }
          } else {
            return {
              description: question.description.replaceAll('[', '{').replaceAll(']', '}'),
              position: index + 1,
              questionType: question.questionType,
              continueCall: question.continueCall,
              scriptType: question.scriptType,
            }
          }
        })
        const dualQuestions = formattedQuestions
          .filter((question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.dual)
          .map((question: any, index: number) => ({...question, position: index + 1}))
        const electricQuestions = formattedQuestions
          .filter((question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.electric)
          .map((question: any, index: number) => ({...question, position: index + 1}))
        const gasQuestions = formattedQuestions
          .filter((question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.gas)
          .map((question: any, index: number) => ({...question, position: index + 1}))
        const solarQuestions = formattedQuestions
          .filter((question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.solar)
          .map((question: any, index: number) => ({...question, position: index + 1}))
        return {
          languageId: language.languageId,
          questions: [...dualQuestions, ...electricQuestions, ...gasQuestions, ...solarQuestions],
        }
      }),

      productIds: selectedProducts.map((selectProduct: any) => selectProduct.value),
    }

    const {deleteProducts, deleteScriptLanguages, deleteScriptQuestions, ...createProps} =
      finalpayload
    if (modalConfig.mode === 'create' || modalConfig.mode === 'clone') {
      createScript({variables: {createScriptInput: createProps}})
    } else {
      finalpayload = {
        ...finalpayload,
        //to send only added product ID compare the final products and remove existing product Id
        productIds: finalpayload.productIds.filter(
          (productid: any) => !dataFromGetscript.existingProducts.includes(productid)
        ),
        //to send only added language ID compare the final language and remove existing language Id
        languageIds: finalpayload.languageIds.filter(
          (langid: any) => !dataFromGetscript.exisitingLanguages.includes(langid)
        ),
      }
      updateScript({
        variables: {updateScriptInput: {...finalpayload, scriptId: modalConfig.scriptId}},
      })
    }
  }
  const [speakingId, setSpeakingId] = useState('')
  const promptValidation = () => {
    const nullVal = payload.scriptQuestions.map((scriptByLang: any) =>
      scriptByLang.questions?.some((question: any) => question.description === '')
    )

    !nullVal.includes(true) && setCurrentScreen('preview')
  }
  const audioRef: any = useRef()
  const EditOrPreviewHeader = modalConfig.mode === 'edit' ? 'Edit' : 'Preview'

  const validCreateScript = () => !Boolean(payload.name) || selectedLanguage.length === 0
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-xl '
      show={show}
      backdrop={true}
      className=''
    >
      <div className='modal-header py-7 d-flex justify-content-between'>
        <h2>
          {`${
            modalConfig.mode === 'create' || modalConfig.mode === 'clone'
              ? 'Create'
              : EditOrPreviewHeader
          }`}{' '}
          Script
        </h2>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => handleModalClose()}
        >
          <span className='svg-icon svg-icon-1'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect
                opacity='0.5'
                x='6'
                y='17.3137'
                width='16'
                height='2'
                rx='1'
                transform='rotate(-45 6 17.3137)'
                fill='currentColor'
              ></rect>
              <rect
                x='7.41422'
                y='6'
                width='16'
                height='2'
                rx='1'
                transform='rotate(45 7.41422 6)'
                fill='currentColor'
              ></rect>
            </svg>
          </span>
        </div>
      </div>
      <div className='modal-body min-h-300px my-lg-10 p-lg-0 script-modal-container'>
        {!loadedData ? (
          <div className='text-center'>
            <Spinner animation='border' className='text-gray-600' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <div
              className='stepper stepper-links px-4 d-flex flex-column between'
              id='create_script_stepper'
              data-kt-stepper='true'
            >
              <div className='stepper-nav mb-3 justify-content-center py-2'>
                <div
                  className={`stepper-item me-5 me-md-15 cursor-pointer ${
                    currentScreen === 'createScript' ? 'current' : 'pending'
                  } ${modalConfig.mode === 'preview' ? 'completed' : ''}`}
                  onClick={() => {
                    modalConfig.mode !== 'preview' && setCurrentScreen('createScript')
                  }}
                  data-kt-stepper-element='nav'
                >
                  <h3 className='stepper-title'>{`${
                    modalConfig.mode === 'edit' ? 'Edit' : 'Create'
                  } Script`}</h3>
                </div>
                <div
                  className={`stepper-item me-5 me-md-15 cursor-pointer ${
                    currentScreen === 'dialinnumber' ? 'current' : 'pending'
                  } ${validCreateScript() ? 'completed' : ''} ${
                    modalConfig.mode === 'preview' && 'completed'
                  }`}
                  onClick={() => {
                    !validCreateScript() &&
                      modalConfig.mode !== 'preview' &&
                      setCurrentScreen('dialinnumber')
                  }}
                  data-kt-stepper-element='nav'
                >
                  <h3 className='stepper-title'>Dial In Numbers</h3>
                </div>
                <div
                  className={`stepper-item me-5 me-md-15 cursor-pointer ${
                    currentScreen === 'createPrompt' ? 'current' : 'pending'
                  } ${validCreateScript() ? 'completed' : ''} ${
                    modalConfig.mode === 'preview' && 'completed'
                  }`}
                  onClick={() => {
                    !validCreateScript() &&
                      modalConfig.mode !== 'preview' &&
                      setCurrentScreen('createPrompt')
                  }}
                  data-kt-stepper-element='nav'
                >
                  <h3 className='stepper-title'>Create Prompts</h3>
                </div>
                <div
                  className={`stepper-item me-5 me-md-15 cursor-pointer ${
                    currentScreen === 'preview' ? 'current' : 'pending'
                  } ${!Boolean(payload.name) || selectedLanguage.length === 0 ? 'completed' : ''} `}
                  onClick={() => {
                    !(!Boolean(payload.name) || selectedLanguage.length === 0) &&
                      setCurrentScreen('preview')
                  }}
                  data-kt-stepper-element='nav'
                >
                  <h3 className='stepper-title'>Preview</h3>
                </div>
              </div>

              <div
                className={`row ${currentScreen === 'createScript' ? 'current' : 'pending'}`}
                data-kt-stepper-element='content'
              >
                <CreateScriptBody
                  payload={payload}
                  setPayload={setPayload}
                  languageData={languages}
                  productsData={products}
                  selectedLanguage={selectedLanguage}
                  setSelectedLanguage={setSelectedLanguage}
                  selectedProducts={selectedProducts}
                  setSelectedProducts={setSelectedProducts}
                  dataFromGetScript={dataFromGetscript}
                />
              </div>
              <div
                className={`row ${currentScreen === 'dialinnumber' ? 'current' : 'pending'}`}
                data-kt-stepper-element='content'
              >
                <DialInNumber
                  payload={payload}
                  setPayload={setPayload}
                  dialInNumbers={dialInNumbers}
                  setDialInNumbers={setDialInNumbers}
                  selectedLanguage={selectedLanguage}
                />
              </div>
              <div
                className={`row ${currentScreen === 'createPrompt' ? 'current' : 'pending'}`}
                data-kt-stepper-element='content'
              >
                <CreatePrompts
                  payload={payload}
                  setPayload={setPayload}
                  languagesSelected={selectedLanguage}
                  dataFromGetScript={dataFromGetscript}
                  availableLanguages={languages}
                  setSelectedLanguage={setSelectedLanguage}
                  modalConfig={modalConfig}
                  isSolarProduct={isSolarProduct}
                />
              </div>
              <div
                className={`row ${currentScreen === 'preview' ? 'current' : 'pending'}`}
                data-kt-stepper-element='content'
              >
                <CreatePreview
                  cancel={cancelAudio}
                  audio={audio}
                  audioRef={audioRef}
                  payload={payload}
                  languagesSelected={selectedLanguage}
                  setSpeakingId={setSpeakingId}
                  speakingId={speakingId}
                  isplayingplayAll={isplayingplayAll}
                  setIsPlayingPlayAll={setIsPlayingPlayAll}
                  isSolarProduct={isSolarProduct}
                />
                <audio ref={audioRef} preload='auto' src=''></audio>
              </div>
            </div>
          </>
        )}
      </div>
      {modalConfig.mode !== 'preview' && (
        <div className={`modal-footer d-block `}>
          <div
            className={`script-modal-container d-flex ${
              currentScreen === 'createScript' ? 'justify-content-end' : 'justify-content-between'
            }`}
          >
            {currentScreen === 'dialinnumber' && (
              <div className=''>
                <button
                  className='btn btn-light'
                  onClick={() => setCurrentScreen('createScript')}
                >{`${modalConfig.mode === 'edit' ? 'Edit' : 'Create'} Script`}</button>
              </div>
            )}
            {currentScreen === 'createScript' && (
              <div className=''>
                <Button
                  className='btn btn-primary'
                  onClick={() => setCurrentScreen('dialinnumber')}
                  disabled={validCreateScript()}
                >
                  Dial In Numbers
                </Button>
              </div>
            )}

            {currentScreen === 'dialinnumber' && (
              <div className=''>
                <button className='btn btn-primary' onClick={() => handleCreatePrompt()}>{`${
                  modalConfig.mode === 'edit' ? 'Edit' : 'Create'
                } Prompts`}</button>
              </div>
            )}
            {currentScreen === 'createPrompt' && (
              <>
                <button className='btn btn-light' onClick={() => setCurrentScreen('dialinnumber')}>
                  Dial In Numbers
                </button>
                <button className='btn btn-primary' onClick={() => promptValidation()}>
                  Preview Prompts
                </button>
              </>
            )}
            {currentScreen === 'preview' && (
              <>
                <button
                  className='btn btn-light'
                  onClick={() => setCurrentScreen('createPrompt')}
                >{`${modalConfig.mode === 'edit' ? 'Edit' : 'Create'} Prompts`}</button>
                <button className='btn btn-primary' onClick={() => handleAPI()}>
                  Submit
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </Modal>,
    modalsRoot
  )
  // <div className='modal fade' id='create-script'>
  //   <div className='modal-dialog modal-dialog-centered mw-1000px'>
  //     <div className='modal-content'>

  //     </div>
  //   </div>
  // </div>
}
export default CreateScript
